module.exports = __webpack_public_path__ + "img/match-signup-symbol.2597ada1.svg";